/**
 * Reads the password-reset token from hash-router URLs and legacy malformed links.
 *
 * Correct:  http://host/#/set-password?token=...
 * Legacy:   http://host/set-password?token=...#/login
 */
export function readPasswordResetToken(): string | null {
  const hash = window.location.hash;
  if (hash.includes('?')) {
    const query = hash.slice(hash.indexOf('?') + 1);
    const fromHash = new URLSearchParams(query).get('token');
    if (fromHash) {
      return fromHash;
    }
  }

  const fromPathSearch = new URLSearchParams(window.location.search).get('token');
  if (fromPathSearch) {
    return fromPathSearch;
  }

  return null;
}

/** Rewrites legacy /set-password?token=...#/... links to hash-router form. */
export function normalizeSetPasswordUrl(): void {
  const token = readPasswordResetToken();
  if (!token) {
    return;
  }

  if (window.location.hash.startsWith('#/set-password')) {
    return;
  }

  const pathLooksLikeSetPassword = window.location.pathname.replace(/\/$/, '') === '/set-password';
  const hasTokenInSearch = window.location.search.includes('token=');

  if (pathLooksLikeSetPassword || hasTokenInSearch) {
    const target = `${window.location.origin}/#/set-password?token=${encodeURIComponent(token)}`;
    window.location.replace(target);
  }
}
